import { ContentBlock } from 'braid-design-system';

import { ResumeHeader } from '../ResumeHeader/ResumeHeader';

export const PageHeader = () => (
  <ContentBlock width="medium">
    <ResumeHeader />
  </ContentBlock>
);

export default PageHeader;
